var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#1D1E21"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.144 28.5394C55.9717 28.5394 59.1442 26.2148 59.8857 21.1428C57.0285 23.1699 53.445 23.6939 48.9591 23.6939C35.645 23.6939 36.2865 29.361 31.0004 34.433C28.6433 36.6994 24.0444 37.0121 22.8571 35.8497C22.8571 39.0089 26.7429 40.3416 29.287 40.3416C31.6897 40.3804 34.0164 39.5006 35.7864 37.8897C40.8724 32.9601 39.4003 28.5394 49.144 28.5394Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2876 40.3656C49.3048 40.3656 45.4352 40.3656 42.0693 43.724C39.1516 46.6444 35.3375 51.6241 32.2533 51.6241C25.9142 51.6241 24.7232 48.6328 21.1609 48.6328C18.4545 48.6049 16 50.3121 16 53.0628C19.4641 49.5798 24.7659 58.1713 32.9256 58.1713C37.8902 58.1713 40.4984 54.2631 42.7416 51.9633C43.2475 51.4544 46.7393 45.7275 53.2876 45.7275C58.8967 45.7275 63.2999 43.2022 64 37.5999C61.1954 40.5632 57.7036 40.3656 53.2876 40.3656Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRounded);
export default __webpack_public_path__ + "static/media/logo-rounded.af7201544987be65f2ccac92dc01fb85.svg";
export { ForwardRef as ReactComponent };